import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	selectStatusState
} from './statusbarSlice';


import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import IconButton from '@mui/material/IconButton';

//CSS Styles
import flexstyles from '../../../../../css/FlexCss';
import useClasses from '../../../../../ui/useClasses';
import { useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import styles from './StatusBar.module.css';

//Icons
import ReportProblemIcon from '@mui/icons-material/ReportProblem';


export function StatusBar() {
	/* CSS and Media Queries */
	
	const classes = useClasses(flexstyles);

	const statusbar = useSelector(selectStatusState);

	const [expandresults, setExpandResults] = useState(false);
	const ExpandResults = () => {
		setExpandResults(!expandresults);
	}

	var statusbarstyle = {
		display:"flex",
		alignItems:"center",
		width:"100%",
		backgroundColor:"#CCC",
		padding: { xs: "2px 3px 2px 5px", sm: "2px 3px  2px 5px", md: "3px 3px 2px 8px", lg: "3px 4px 2px 8px" },       // px (theme spacing units)
		fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
	};

	var warningstatusbarstyle = {
		display:"flex",
		alignItems:"center",
		width:"100%",
		backgroundColor:"#CCC",
		padding: { xs: "0px 4px", sm: "2px 1px", md: "2px 3px", lg: "2px 4px" },       // px (theme spacing units)
		fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
	};

	var progressstatusbarstyle = {
		
		borderRadius: "2px",
		//border: "1px ridge rgb(167, 167, 167)",
		boxShadow: "0px 0px 2px 2px #AAA",
		width:"100%",
		position:"relative", zIndex:1200,
		//display:"flex",
		alignItems:"flex-start",
		width:"100%",
		backgroundColor:"#EEE",
		fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
	};

	const CopyErrors = (errors) =>{
		let errorstrings = errors.slice();
		for (var i=0; i<errorstrings.length; i++){
			errorstrings[i] = "Error "+(i+1)+": "+errorstrings[i];
		}
		const textToCopy = errorstrings.join('\n');
		navigator.clipboard.writeText(textToCopy)
	}

	return (
		<>
				{(statusbar.statusbarstate.type==="progress" && statusbar.statusbarstate.show) &&

				<Box sx={progressstatusbarstyle}>
					<Box sx={{width:"100%", display:"flex", padding:"2px 3px"  }}>
						<Box sx={{ width: "calc(100% - 30px)", borderRadius: "4px", border: "1px solid #074507" }}>
							{/* Background of Idle Bar - Is Green when all looks OK. Is orange when an error was found. */}
							<div style={{ backgroundColor: (statusbar.statusbarstate.fail === 0) ? "#85bd85" : "#bdb285", position: "relative" }}>
								<div style={{ position: "absolute", width: "100%", textAlign: "center" }}>
									{(statusbar.statusbarstate.fail === 0) &&
										<React.Fragment>
											{(statusbar.statusbarstate.finished === statusbar.statusbarstate.total) &&
												<span style={{ margin: "2px", color: "#FFF" }}>Completed {statusbar.statusbarstate.total} {statusbar.statusbarstate.itemtype}</span>
											}
											{(statusbar.statusbarstate.finished !== statusbar.statusbarstate.total) &&
												<span style={{ margin: "2px", color: "#FFF" }}>{statusbar.statusbarstate.finished} / {statusbar.statusbarstate.total}</span>
											}
										</React.Fragment>
									}
									{(statusbar.statusbarstate.fail !== 0) &&
										<span style={{ margin: "2px", color: "#FFF" }}>Passed: {statusbar.statusbarstate.pass} / Failed: {statusbar.statusbarstate.fail}</span>
									}

								</div>
								<div style={{ width: statusbar.statusbarstate.percent, backgroundColor: (statusbar.statusbarstate.fail === 0) ? "green" : "#f35600", height: "23px", textAlign: "center" }}>
								</div>
							</div>
						</Box>

						<Box sx={{ display: "inline-block", height: "24px", textAlign: "center", verticalAlign: "top", paddingLeft: "5px" }}>
							<IconButton className={classes.transparenticon} size="medium" aria-label="expand" onClick={() => { ExpandResults() }}>
								{(!expandresults) &&
									<ExpandMoreIcon color="#222" sx={{ fontSize: "25px" }}></ExpandMoreIcon>
								}
								{(expandresults) &&
									<ExpandLessIcon color="#222" sx={{ fontSize: "25px" }}></ExpandLessIcon>
								}
							</IconButton>
						</Box>
					</Box>
					
					{(expandresults) &&
						<Box style={{ padding: "5px" , width:"100%", backgroundColor:"#FFF", marginTop:"0px", borderTop:"1px solid #999"}}> 
							Pass: {statusbar.statusbarstate.pass}<br></br>
							Fail: {statusbar.statusbarstate.fail}<br></br>
							Percent: {statusbar.statusbarstate.percent}<br></br>
							Total:{statusbar.statusbarstate.total}<br></br>
							Finished:{statusbar.statusbarstate.finished}<br></br>
							Timeout ID: {statusbar.statusbarstate.timeoutid}<br></br>
							{statusbar.statusbarstate.errors.map((error, errorindex) => {
								if (errorindex < 3) {
									return (
										<div key={errorindex}>
											Error {errorindex + 1}: {error}
										</div>
									)
								}
							})}

							{(statusbar.statusbarstate.errors.length > 3) &&
								<div>
									<a className={classes.hoverunit} onClick={() => CopyErrors(statusbar.statusbarstate.errors)}>Copy All Errors</a>
								</div>
							}


						</Box>
					}
				</Box>






				// <div style={{position:"relative", height:"33px"}}>
				// 	<div style={{ border: "2px solid #CCC", padding: "2px", width: "260px", zIndex: 1199, backgroundColor: "#FFF", height: (expandresults) ? "" : "33px", position:"absolute", right:"0px"}}>
				

				// 	</div>
				// </div>
				
			}

			{(statusbar.statusbarstate.type === "dataloaded" && statusbar.statusbarstate.show) &&
				<Box sx={statusbarstyle} className={styles.container}>
					Ready
				</Box>
			}

			{(statusbar.statusbarstate.type === "itemsselected" && statusbar.statusbarstate.show) &&
				<Box sx={statusbarstyle} className={styles.container}>
					<span style={{color:"green"}}>{statusbar.statusbarstate.msg}</span>
				</Box>
			}

			{(statusbar.statusbarstate.type === "warning" && statusbar.statusbarstate.show) &&
				<Box sx={warningstatusbarstyle}>
					<ReportProblemIcon sx={{color:"#ffe27f", paddingLeft:"3px"}} />&nbsp;&nbsp;{statusbar.statusbarstate.msg}
				</Box>
			}


		</>
		
	)
}
